import { createSlice } from "@reduxjs/toolkit";
import { axiosInstance } from "../../../utils/client";
import { setLoading } from "../filter/filterSlice";

type BusinessLocationState = {
  isLoading: boolean;
  hasError: any;
  businessLocations: any[];
  selectedBusinessLocation: any;
};

const initialState: BusinessLocationState = {
  isLoading: true,
  hasError: null,
  businessLocations: [],
  selectedBusinessLocation: undefined,
};

const slice = createSlice({
  name: "businessLocation",
  initialState,
  reducers: {
    setisLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setBusinessLocations: (state, action) => {
      // console.log(action.payload);
      state.isLoading = false;
      state.businessLocations = action.payload.businessLocations;
      // debugger
      if (action.payload.selectedBusinessLocation) {
        state.selectedBusinessLocation =
          action.payload.selectedBusinessLocation;
      }
    },
    setSelectedBusinessLocations: (state, action) => {
      state.selectedBusinessLocation = action.payload;
    },
  },
});

export const {
  setBusinessLocations,
  setisLoading,
  setSelectedBusinessLocations,
} = slice.actions;

export default slice.reducer;

// -------------------------------------------------------------

export function getBusinessLocations() {
  return async (dispatch: any, getState: () => any) => {
    const { selectedBusinessLocation } = getState().businessLocation;
    // console.log(selectedBusinessLocation);

    try {
      dispatch(setLoading(true));
      const response = await axiosInstance.get("/business_locations");
      // console.log(response.data);
      if (response.status === 200) {
        dispatch(
          setBusinessLocations({
            businessLocations: response.data,
          })
        );
      } else {
        dispatch(setLoading(false));
      }
    } catch (error) {
      console.log(error);
    }
  };
}
